import { HttpErrorResponse } from '@angular/common/http';

import { Company, CreateCompany } from '@recruitee/http-types';
import { createSingleEntityStore } from '@recruitee/ngrx';

const { actions, selectors, reducer, namespace } = createSingleEntityStore<Company | null>()(
  'company',
  {
    customActions: adapter => ({
      create: (state, payload: { body: CreateCompany; skipCompany?: boolean }) => state,
      createSuccess: (state, payload: Company) => state,
      createFailed: (state, payload: HttpErrorResponse) => state,

      leave: (state, payload: { id: Company['id'] }) => state,
      leaveSuccess: (state, payload: Company) => state,
      leaveFailed: (state, payload: HttpErrorResponse) => state,

      update: (state, payload: Partial<Company> & { secureChangeToken?: string }) =>
        adapter.markAsPending(state),
    }),
  },
);

const CompanyActions = <
  Pick<
    typeof actions,
    | 'update'
    | 'updateSuccess'
    | 'updateFailed'
    | 'create'
    | 'createSuccess'
    | 'createFailed'
    | 'leave'
    | 'leaveSuccess'
    | 'leaveFailed'
  >
>actions;

export {
  actions,
  CompanyActions,
  reducer as CompanyReducer,
  namespace as CompanyNamespace,
  selectors as CompanySelectors,
};
